export const REGISTER_USER_RESET = 'REGISTER_USER_RESET';
export const REGISTER_USER_SET = 'REGISTER_USER_SET';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';